<template>

    <div class="nav-tabs-custom">
        <div class="tab-content">
            <div class="tab-pane active">
                <default-server-table
                    v-if="loaded"
                    :add-url="route('documents.add.index', {}, false)"
                    :data-url="st.url"
                    :data-columns="JSON.stringify(st.columns)"
                    :preference-url="st.preferenceUrl"
                    :templates-uri="route('api.v1.templates.index')"
                ></default-server-table>
            </div>
        </div>
    </div>

</template>

<script>

import DefaultServerTable from "../../Libraries/ServerTable/DefaultServerTable";
import axios from "axios";

export default {

    components: {
        DefaultServerTable,
    },

    data() {
        return {
            loaded:false,
            st: {
                columns:[],
                url:'',
                preferenceUrl:'',
            }
        }
    },

    metaInfo: {
        title:'My Documents',
    },

    methods: {
        getPersonalDocumentsData() {
            axios.get(this.route('api.v1.documents.personal.st'))
            .then(resp => {
                this.st = resp.data;
                this.loaded = true;
            })
        }
    },

    mounted() {
        this.getPersonalDocumentsData();
    },

    name:'DocumentsPersonal',

}

</script>
